<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2022-2023 (original work) Open Assessment Technologies SA ;
    import { onMount, onDestroy } from 'svelte';
    import { __ } from '@oat-sa-private/ui-core';
    import { Icon } from '@oat-sa-private/ui-elements';
    import { getTimeSince } from './time.js';
    import { getLiveSaveStore, liveSaveStatuses } from './liveSaveStore.js';

    export let namespace = 'livesave';

    export let withTime = false;

    // Get a LSI store based on namespace (or create one based on ns)
    const liveSaveApi = getLiveSaveStore(namespace);

    /**
     * The only part of the store API needed here is the output store
     * @property {svelte/store} liveSaveStore
     * @property {String} liveSaveStore.state
     * @property {DateTime} liveSaveStore.lastSave
     */
    const liveSaveStore = liveSaveApi.liveSaveStore;

    // Set the human time initially, update it whenever the stored timestamp changes and also update UI string on a regular interval
    let interval;

    onMount(() => {
        if (withTime) {
            interval = setInterval(() => {
                humanTimeAgo = getTimeSince($liveSaveStore.lastSaved);
            }, 10 * 1000);
        }
    });

    onDestroy(() => {
        clearInterval(interval);
    });

    $: humanTimeAgo = withTime && getTimeSince($liveSaveStore.lastSaved);
</script>

<style>
    .livesave {
        font-size: var(--fontsize-body-s);
        color: var(--color-text-disabled);
        min-width: 10rem;
        /* chosen widths allow English text to fit, while preventing size changes that look distracting */
        &.wide {
            min-width: 22rem;
        }
    }
</style>

<span class="livesave" class:wide={withTime}>
    {#if $liveSaveStore.status === liveSaveStatuses.waiting}
        <span class="status waiting">...</span>
    {:else if $liveSaveStore.status === liveSaveStatuses.saved}
        <span>
            <Icon name="check-16" ariaHidden={true} />
        </span>
        <span class="status saved">
            {#if withTime}
                {humanTimeAgo}
            {:else}
                {__('saved')}
            {/if}
        </span>
    {/if}
</span>
